import * as React from 'react';
import styled from "styled-components"
import { DictioneryPanel } from '../../../Data/DictioneryPanel';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { paramsToObject } from '../../../components/Functions/Helpers';
import { TextBtn2 } from '../../../components/Inputs/TextBtn2';
import { IconEdit } from '../../../Assets/panels/IconEdit';
import HotelCart from '../../../components/Carts/HotelCart';
import BoxDesign from '../../../components/Carts/BoxDesign';
import { LoadingColor } from '../../../components/LoadingColor';
import { useState } from 'react';
import { useEffect } from 'react';
import { GetDataPromise } from '../../../components/Functions/SendingData';
import { apiMain } from '../../../App';
import { CountriesSelector } from '../../../components/Inputs/CountriesSelector';
import { CitiesSelector } from '../../../components/Inputs/CitiesSelector';
import { TextInputWTitle } from '../../../components/Inputs/TextInputWTitle';

const Styles = styled.div`
  flex-grow: 1;
  min-height: calc(100svh - 60px);
  &.rtl {
    
  }
  .filters {
    margin: 1rem 1rem 1rem;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
    align-items: center;
    position: relative;
    padding: 1.5rem 2rem 0.5rem;
  }
  .title-box {
    margin: 1rem 1rem 1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    .title {
      padding: 1.5rem 2rem;
      font-size: 1.25rem;
      font-weight: 700;
    }
    .actions {
      padding: 0 2rem;
      display: flex;
      justify-content: end;
      gap: 0.5rem;
    }
  }
  .contents {
    margin: 0 1rem 1.5rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
  @media screen and (max-width: 850px) {
    padding-bottom: 80px;
    .filters {
      padding: 1.5rem 1rem 0.5rem;
      grid-template-columns: repeat(1, 1fr);
      gap: 0.5rem;
    }
    .title-box {
      .title {
        padding: 1.5rem 1rem;
      }
      .actions {
        padding: 0 1rem;
      }
    }
  }
`
export default function Hotels (props) {
    const {user, lang, agenciesData} = props;
    const location = useLocation()
    const navigate = useNavigate()
    const searchParams = new URLSearchParams((location.search) ? location.search : "");
    const searchData = paramsToObject(searchParams, {});
    const [loading, setLoading] = useState(false);
    const [data, setDeta] = useState([]);
    // check subsystem
    useEffect(() => {
      if(!loading){
        getData(searchData);
      }
    }, [])
    useEffect(() => {
      const searchParams2 = new URLSearchParams((location.search) ? location.search : "");
      const searchData2 = paramsToObject(searchParams2, {});
      getData(searchData2);
    }, [location.search])

    const getData = async (items = {}, force = false, loadingForce = true) => {
      if(loadingForce){
        setLoading(true);
      }
      let formData = new URLSearchParams();
      formData.append("Agency_Id", agenciesData.Agency_Id);
      let sendKeys = [
        "Country_Id",
        "City_Id",
      ]
      for (let i = 0; i < sendKeys.length; i++) {
        const key = sendKeys[i];
        if(items[key]){
          formData.append(key, items[key]);
        }
      }
      let res = await GetDataPromise(`${apiMain}/api/v1/agencies/broker_hotels_select?${formData.toString()}`);
      let parsed = JSON.parse(res);
      if((parsed.status && parsed.status !== "error") || parsed.status === "success"){
        let data = parsed.data;
        if(items["Name"] && items["Name"] !== ""){
          data = parsed.data.filter((v) => {
            if(v.Hotel_Name.toLowerCase().search(items["Name"].toLowerCase()) !== -1){
              return true;
            }
            if(v.Hotel_En_Name.toLowerCase().search(items["Name"].toLowerCase()) !== -1){
              return true;
            }
            return false;
          });
        }
        setDeta(data);
        setLoading(false);
        return;
      }
      setDeta([]);
      setLoading(false);
    }

    const makeHotels = () => {
      if(loading){
        return (
            <LoadingColor/>
        )
      }
      return data.map((v, i) => {
        let searchParams = new URLSearchParams();
        searchParams.append("Hotel_Id", v.Hotel_Id)
        searchParams.append("City_Id", v.City_Id)
        searchParams.append("Country_Id", v.Country_Id)
        return (
          <HotelCart 
            {...props} 
            v={v} 
            i={i} 
            key={i} 
            editFunc={() => {
              let newLocation = location.pathname.split("/");
              newLocation.pop()
              newLocation.pop()
              navigate(newLocation.join("/") + "/tour2/hotels-form?"+ searchParams.toString())
            }}
            deleteFunc={() => {
              let promt = DictioneryPanel.hotelsDict.deleteHotel[lang];
              let name = v.Hotel_En_Name;
              if(lang === "fa"){
                name = v.Hotel_Name
              }
              promt = promt.replace("[hotelname]", name);
              let confirm = window.confirm(promt)
            }}
          />
        )
      }) 
    }
    const setData = (items = {}) => {
      let formData = new URLSearchParams();
      let keys = Object.keys(items);
      for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        formData.append(key, items[key]);
      }
      navigate(location.pathname + "?" + formData.toString())
    }
    const onChange = (e) => {
      const value = e.target.value;
      const name = e.target.name;
      let temp = {...searchData};
      temp[name] = value;
      setData(temp);
    }
    return (
        <Styles className={((lang !== "fa") ? "ltr" : "rtl")}>
          <BoxDesign className='title-box'>
            <div className='title'>
              {DictioneryPanel.hotels[lang]}
            </div>
            <div className='actions'>
              <TextBtn2 
                style={{minWidth: "200px"}}
                text={
                  <div className='simple-text'>
                    {DictioneryPanel.hotelsDict.addHotel[lang]}
                  </div>
                }
                newType={1}
                onclick={() => {
                  let newLocation = location.pathname.split("/");
                  newLocation.pop()
                  newLocation.pop()
                  navigate(newLocation.join("/") + "/tour2/hotels-form?Hotel_Id=new")
                }}
              />
            </div>
          </BoxDesign>
          <BoxDesign className={"filters"}>
            <CountriesSelector
              style={{minWidth: "200px"}}
              first={true}
              selectableFirst={true}
              title={DictioneryPanel.filterDict.country[lang]}
              name={"Country_Id"}
              value={(searchData.Country_Id) ? searchData.Country_Id : ""}
              onchange={onChange}
              lan={(lang !== "fa") ? true : false}
            />
            <CitiesSelector
              style={{minWidth: "200px"}}
              first={true}
              selectableFirst={true}
              Country_Id={(searchData.Country_Id) ? searchData.Country_Id : ""}
              title={DictioneryPanel.filterDict.city[lang]}
              name={"City_Id"}
              value={(searchData.City_Id) ? searchData.City_Id : ""}
              onchange={onChange}
              lan={(lang !== "fa") ? true : false}
            />
            <TextInputWTitle
              style={{minWidth: "200px"}}
              title={DictioneryPanel.filterDict.name[lang]}
              name={"Name"}
              value={(searchData.Name) ? searchData.Name : ""}
              onchange={onChange}
              lan={(lang !== "fa") ? true : false}
            />
          </BoxDesign>
          <div className='contents'>
            {makeHotels()}
          </div>
        </Styles>
    )
}